import store from '@/store'

function checkPermission(el, binding) {
  const roles = store.getters && store.getters.roles
  const { value } = binding
  if (value) {
    const permissionRoles = value
    const hasPermission = roles.some(role => {
      return permissionRoles.includes(role)
    })
    if (!hasPermission) {
      el.parentNode && el.parentNode.removeChild(el)
      // console.log(el)
      // el.remove()
      // el.style.display = 'none'
    }
  } else {
    throw new Error(`need roles! Like v-permission="['admin','editor']"`)
  }
}
export default {
  inserted(el, binding) {
    checkPermission(el, binding)
  },
  update(el, binding) {
    checkPermission(el, binding)
  }
}
